import { StateCreator } from "zustand";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { FetchBrickAreaLocationType } from "../../../domain/models/brick-management-report/brick-management-data";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";

import Endpoints from "../../../domain/endpoints";
import { fetchBrickAreaLocation } from "../../../domain/useages/brick-management/fetch-brick-area-location";
import { RemoteFetchBrickAreaLocation } from "../../../data/usecases/brick-management/remote-fetch-brick-area-location";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface fetchBrickAreaLocationInterface {
  FetchBrickAreaLocation: FetchBrickAreaLocationType;
  FetchBrickAreaLocationState: FetchState;
  fetchBrickAreaLocation: Function;
}

const initialStates = {
  FetchBrickAreaLocation: {} as FetchBrickAreaLocationType,
  FetchBrickAreaLocationState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchBrickAreaLocationSlice: StateCreator<
  fetchBrickAreaLocationInterface
> = (set) => ({
  ...initialStates,
  fetchBrickAreaLocation: async (params: fetchBrickAreaLocation.Params) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchBrickAreaLocation = new RemoteFetchBrickAreaLocation(
      `${BASE_URL}${Endpoints.FETCH_BRICK_AREA_LOCATION}`,
      axiosHttpClient
    );

    let result = await remoteFetchBrickAreaLocation.fetch(params);
    set(() => ({
      FetchBrickAreaLocation: result,
      FetchBrickAreaLocationState: FetchState.SUCCESS,
    }));
    return result;
  },
});
